import React from 'react'
import { Center, VStack, Text, Button } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { FiUploadCloud } from 'react-icons/fi'
import { useAppTranslation } from '@/contexts/LanguageContext'
import { buttonVariants } from '@/theme/animations'

const MotionBox = motion.div
const MotionButton = motion(Button as any)

interface EmptyStateProps {
  onUpload: () => void
}

export default function EmptyState({ onUpload }: EmptyStateProps) {
  const { t } = useAppTranslation('files')

  return (
    <MotionBox
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <Center>
        <VStack spacing={6}>
          {/* <Icon as={FiFile} boxSize={16} color="gray.400" /> */}
          <VStack spacing={3}>
            <Text fontSize="2xl" fontWeight="bold" color="gray.700">
              {t('fileExplorer.emptyFolder')}
            </Text>
            <Text color="gray.500" textAlign="center" fontSize="lg" maxW="md">
              {t('fileExplorer.selectFiles')}
            </Text>
          </VStack>
          <MotionButton
            leftIcon={<FiUploadCloud />}
            colorScheme="brand"
            size="lg"
            borderRadius="xl"
            h="56px"
            px={8}
            onClick={onUpload}
            variants={buttonVariants}
            whileHover="hover"
            whileTap="tap"
            boxShadow="lg"
            bg="brand.500"
            fontWeight="600"
            _hover={{
              boxShadow: 'xl',
              transform: 'translateY(-2px)',
            }}
            _active={{
              transform: 'translateY(0)',
            }}
            transition="all 0.2s"
          >
            {t('fileExplorer.uploadFiles')}
          </MotionButton>
        </VStack>
      </Center>
    </MotionBox>
  )
}
